import { getApiClient } from '../../api/client';

export async function listDripCampaigns(days = 30) {
  const client = getApiClient();
  const { data, error } = await client.GET('/drip/campaigns', {
    params: { query: { days } },
  });
  if (error) throw new Error(`Failed to list campaigns: ${JSON.stringify(error)}`);
  return data;
}

export async function getCampaignStats(uuid: string, days = 30) {
  const client = getApiClient();
  const { data, error } = await client.GET('/drip/campaigns/{uuid}/stats', {
    params: { path: { uuid }, query: { days } },
  });
  if (error) throw new Error(`Failed to fetch campaign stats: ${JSON.stringify(error)}`);
  return data;
}

export async function getCampaignTimeseries(uuid: string, days = 30) {
  const client = getApiClient();
  const { data, error } = await client.GET('/drip/campaigns/{uuid}/timeseries', {
    params: { path: { uuid }, query: { days } },
  });
  if (error) throw new Error(`Failed to fetch campaign timeseries: ${JSON.stringify(error)}`);
  return data;
}

export async function getCampaignTopUrls(
  uuid: string,
  days = 30,
  limit = 20,
  include_ignored = false,
) {
  const client = getApiClient();
  const { data, error } = await client.GET('/drip/campaigns/{uuid}/top-urls', {
    params: { path: { uuid }, query: { days, limit, include_ignored } },
  });
  if (error) throw new Error(`Failed to fetch campaign top URLs: ${JSON.stringify(error)}`);
  return data;
}
